// extracted by mini-css-extract-plugin
module.exports = {"action":"Icecream_action__2pdH2","demand":"Icecream_demand__1uZE1","highlight":"Icecream_highlight__2k89q","rate":"Icecream_rate__1pYaD"};